import { render, staticRenderFns } from "./ProjectBoardMsg.vue?vue&type=template&id=2feb8a32&scoped=true&"
import script from "./ProjectBoardMsg.vue?vue&type=script&lang=js&"
export * from "./ProjectBoardMsg.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBoardMsg.vue?vue&type=style&index=0&id=2feb8a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb8a32",
  null
  
)

export default component.exports